<template>
    <div :class="styleMain" :style="gridString">
      <el-autocomplete
        v-model="value"
        value-key="label"
        @select="update"
        @change="clear"
        :placeholder="title"
        :fetch-suggestions="querySearch"
        :popper-class="styleMain.join(' ')"
        :clearable="true"/>
      <label v-if="value">{{ title }}</label>
    </div>
</template>

<script>
export default {
  name: 'SportFootballMatchActionPersonTemplate',
  props: {
    title: String,
    grid: String,
    column: String,
    action: Object
  },
  data () {
    return {
      state: null
    }
  },
  computed: {
    gridString () { return 'grid-area: ' + this.grid },
    columnId () { return this.column + 'Id' },
    filterGoalkeeper () { return this.column === 'person2' && (this.action.typeId === 1 || this.action.typeId === 6) },
    filterPlayed () {
      // Todo when squads will be managed
      // return (this.column === 'person' && this.action.typeId === 1) || this.action.typeId === 5
      return false
    },
    filterSubstitute () {
      // Todo when squads will be managed
      // return this.column === 'person' && this.action.typeId === 4
      return false
    },
    filterSubstitued () {
      // Todo when squads will be managed
      // return this.column === 'person2' && this.action.typeId === 4
      return false
    },
    homeAway () { return this.filterGoalkeeper || this.action.owngoal ? this.action.awayHome : this.action.homeAway },
    list () { return this.action.match.squads[this.homeAway].filter(this.filter).map(this.map) },
    filter () {
      if (this.filterGoalkeeper) {
        return (squad) => { return squad.positionId === 1 }
      }
      if (this.filterPlayed || this.filterSubstitued) {
        // Todo
        return (squad) => { return true }
      }
      if (this.filterSubstitute) {
        return (squad) => { return squad.substitute === true }
      }
      return (squad) => { return true }
    },
    map () { return (squad) => { return { id: squad.personId, label: '#' + squad.shirt + ' ' + squad.nickname } } },
    defaultValue () {
      if (this.action[this.columnId]) {
        const found = this.list.find((item) => { return item.id === this.action[this.columnId] })
        if (found) {
          return found.label
        } else {
          return 'Error'
        }
      }
      return null
    },
    value: {
      get () { return this.state !== null ? this.state : this.defaultValue },
      set (value) { this.state = value }
    },

    styleMain () { return ['sportFootballMatchActionPerson', this.homeAway] }
  },
  methods: {
    querySearch (queryString, callback) {
      const results = queryString
        ? this.list.filter((squad) => { return squad.label.toLowerCase().indexOf(queryString.toLowerCase()) > -1 })
        : this.list
      callback(results)
    },
    clear () { this.update() },
    update (value) {
      this.state = null
      const data = { id: this.action.id }
      if (value) {
        value = JSON.parse(JSON.stringify(value))
        data[this.columnId] = value.id
      } else {
        data[this.columnId] = null
      }
      this.$store.dispatch('Sport/Football/Match/putAction', data)
    }
  }
}
</script>

<style>
.sportFootballMatchActionPerson {
  position:relative;
}
.sportFootballMatchActionPerson > div{
  width:100%;
}
.sportFootballMatchActionPerson input{
  font-weight:600;
  height:35px;
  border:none;
  text-align: left;
}
.sportFootballMatchActionPerson.home input{
  color: var(--color-team-home);
}
.sportFootballMatchActionPerson.away input{
  color: var(--color-team-away);
}
.sportFootballMatchActionPerson label{
  position:absolute;
  top:2px;
  left:5px;
  font-size: 8px;
  color: var(--color-font-grey-light)
}
.sportFootballMatchActionPerson li{
  font-weight: 600;
  font-size: 13px;
}
.sportFootballMatchActionPerson.home li{
  color: var(--color-team-home);
}
.sportFootballMatchActionPerson.away li{
  color: var(--color-team-away);
}
</style>
